import { AusState } from "@aus/Store/AusState";
import defaultToOneTimeShipTo from "@aus/Store/Components/DefaultToOneTimeShipTo/Handler/DefaultToOneTimeShipToHandler";
import setUpIntialValueDefaultShipTo from "@aus/Store/Components/DefaultToOneTimeShipTo/Handler/SetupIntialValue";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox/Checkbox";
import Typography from "@insite/mobius/Typography";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    defaultToOneTimeShipTo,
    setUpIntialValueDefaultShipTo,
};

const mapStateToProps = (state: AusState) => ({
    account: state.pages.accountSettings.editingAccount,
    isDefaultToOneTimeShipToEnabled: state.defaultOneTimeShipTo.isDefaultToOneTimeShipToEnabled,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface DefaultToOneShipToStyles {
    defaultToOneTimeShipToCheckbox: CheckboxProps;
}

export const defaultToOneShipToStyles: DefaultToOneShipToStyles = {
    defaultToOneTimeShipToCheckbox: {
        typographyProps: {
            css: css`
                margin-left: 10px;
            `,
        },
    },
};

const styles = defaultToOneShipToStyles;

const DefaultToOneTimeShipTo = ({
    account,
    defaultToOneTimeShipTo,
    setUpIntialValueDefaultShipTo,
    isDefaultToOneTimeShipToEnabled,
}: Props) => {
    if (!account) {
        return null;
    }
    React.useEffect(() => {
        const initialValue = account.properties.defaultToOneTimeShipTo === "true";
        setUpIntialValueDefaultShipTo({
            isDefaultToOneTimeShipToEnabled: initialValue,
        });
    }, []);

    return (
        <>
            <Typography variant="h4"> {translate("Additional Settings")}</Typography>
            <Checkbox
                {...styles.defaultToOneTimeShipToCheckbox}
                onChange={() => defaultToOneTimeShipTo({})}
                checked={isDefaultToOneTimeShipToEnabled}
                data-test-selector="defaultToOneTimeShipTo"
            >
                {translate("Default To One Time Ship To")}
            </Checkbox>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(DefaultToOneTimeShipTo),
    definition: {
        group: "Basic",
        displayName: "Default_To_One_Time Ship_To",
    },
};

export default widgetModule;
